import React from 'react';
import { CheckIcon, FlameIcon, GlobeIcon, LockIcon } from 'lucide-react';
import { packageItems, offerBenefits, images } from '../data/content';
import { SectionHeading } from './SectionHeading';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
const SPOTS_LEFT = 7;
const FILLED = 93;
export function Offer() {
  return <section id="offer" className="bg-navy py-16 sm:py-24" data-id="element-280" data-mp="1hqiml1iliamt">
      <div className="mx-auto max-w-3xl px-4" data-id="element-281" data-mp="tzmpppza8p8p">
        <SectionHeading tone="dark" eyebrow="Your Complete Third Molar Assessment Blueprint™ Package" title="Here’s Everything You’ll Receive Today" data-id="element-282" data-mp="ozryflblhxn4" />

        <div className="mt-10 overflow-hidden rounded-3xl bg-white shadow-[0_30px_80px_-30px_rgba(0,0,0,0.6)]" data-id="element-283" data-mp="13uoegkpnbpar">
          <img src={images.mockup} alt="Complete Third Molar Assessment Blueprint™ package" className="w-full bg-white" data-id="element-284" data-mp="2fc682rdij8jk" />

          <div className="px-5 pb-8 sm:px-10" data-id="element-285" data-mp="2admq1221igwh">
            <ul className="divide-y divide-line" data-id="element-286" data-mp="2actl86mn61gz">
              {packageItems.map(item => <li key={item.title} className="flex items-start gap-3 py-4" data-id="element-287" data-mp="pjz4ly943o0d">
                  <span className="mt-0.5 grid h-6 w-6 shrink-0 place-items-center rounded-full bg-cta text-white" data-id="element-288" data-mp="ui0i83nrqv4g">
                    <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-289" data-mp="zj6da84wiuh5" />
                  </span>
                  <div className="min-w-0 flex-1" data-id="element-290" data-mp="13j74yuh0h265">
                    <p className="font-bold leading-snug text-ink" data-id="element-291" data-mp="6u97h4hvmq5a">{item.title}</p>
                    <p className="mt-1 text-sm leading-relaxed text-muted" data-id="element-292" data-mp="bsu12l2mibkr">{item.text}</p>
                    <p className="mt-1.5 text-sm font-semibold text-muted" data-id="element-293" data-mp="bqg8civf1bgd">
                      Reference value: <span className="line-through" data-id="element-294" data-mp="fskukwjjb5sz">${item.value}</span>
                    </p>
                  </div>
                </li>)}
            </ul>

            <div className="mt-2 rounded-2xl bg-sand p-4 text-center" data-id="element-295" data-mp="3k846a21t7wwr">
              <p className="text-xs font-bold uppercase tracking-[0.14em] text-danger" data-id="element-296" data-mp="3o95xbvlkp2nn">Special Launch Offer</p>
              <p className="mt-1 text-lg font-bold text-ink" data-id="element-297" data-mp="vefsw15ns30k">
                Total reference value: <span className="text-danger line-through" data-id="element-298" data-mp="qhfjphdiik58">$268</span>
              </p>
            </div>

            <div className="mt-6 space-y-1 text-center text-base text-muted" data-id="element-299" data-mp="154il3z4yhcxu">
              <p data-id="element-300" data-mp="105xkhylskr8v">
                You don’t have to pay <span className="line-through" data-id="element-301" data-mp="106z6gy4ciy5d">$268</span>.
              </p>
              <p data-id="element-302" data-mp="chxrst4x6qrn">
                You don’t have to pay <span className="line-through" data-id="element-303" data-mp="ciz7jawvs1fp">$97</span>.
              </p>
            </div>

            <p className="mt-5 text-center text-sm font-bold uppercase tracking-wide text-ink" data-id="element-304" data-mp="7jwb2euyv3jc">
              Today, get the complete Third Molar Assessment Blueprint™ for just:
            </p>
            <p className="mt-2 text-center font-display text-7xl font-bold leading-none text-cta sm:text-8xl" data-id="element-305" data-mp="heo9fkwdhuf6">
              $27<span className="ml-2 align-top text-2xl font-bold text-ink sm:text-3xl" data-id="element-306" data-mp="1wykngg3k4lhd">USD</span>
            </p>

            <ul className="mx-auto mt-6 grid max-w-md gap-2 sm:grid-cols-2" data-id="element-307" data-mp="20enj6gmmfqpx">
              {offerBenefits.map(b => <li key={b} className="flex items-center gap-2 text-[15px] font-semibold text-ink" data-id="element-308" data-mp="25e9xkte6rd0b">
                  <CheckIcon className="h-5 w-5 shrink-0 text-cta" aria-hidden="true" data-id="element-309" data-mp="1qh9d9aybqkbv" />
                  {b}
                </li>)}
            </ul>

            <p className="mt-5 text-center text-sm leading-relaxed text-muted" data-id="element-310" data-mp="1vhdu52359h2m">
              You’ll receive the six-volume collection and all five bonuses in digital format.
            </p>

            <div className="mt-5 flex items-start gap-3 rounded-2xl bg-accentSoft p-4" data-id="element-311" data-mp="2o6ays2efnfcw">
              <GlobeIcon className="mt-0.5 h-5 w-5 shrink-0 text-accent" aria-hidden="true" data-id="element-312" data-mp="29f26flj5bfw2" />
              <p className="text-sm leading-relaxed text-ink" data-id="element-313" data-mp="2eclute9k591q">
                <strong data-id="element-314" data-mp="323r6dh8gtf68">Automatic currency conversion:</strong> the price is shown in USD and is automatically converted to your local
                currency at checkout.
              </p>
            </div>

            <div className="mt-4 rounded-2xl border border-danger/30 bg-danger/5 p-4" data-id="element-315" data-mp="1j7fqgtoafnh2">
              <div className="flex items-center justify-between gap-3" data-id="element-316" data-mp="1e71tc6o85xxt">
                <p className="flex items-center gap-1.5 text-sm font-extrabold text-danger" data-id="element-317" data-mp="1988cq5dn5qtf">
                  <FlameIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-318" data-mp="1495aesp1pyp5" />
                  Only {SPOTS_LEFT} spots left at the promotional price
                </p>
                <span className="text-sm font-extrabold text-danger" data-id="element-319" data-mp="21w4896rh5com">{FILLED}%</span>
              </div>
              <div className="mt-2.5 h-3.5 overflow-hidden rounded-full bg-danger/15" role="progressbar" aria-valuenow={FILLED} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-320" data-mp="1wykt84mycvvm">
                <div className="h-full rounded-full bg-danger" style={{
                width: `${FILLED}%`
              }} data-id="element-321" data-mp="2kp83gwkcbxlc" />
              </div>
              <p className="mt-2 text-xs text-muted" data-id="element-322" data-mp="2o5ktgwvhfw5e">Once these spots are gone, the promotional price is no longer guaranteed.</p>
            </div>

            <div className="mt-7" data-id="element-323" data-mp="2s7ep2qqtm9yp">
              <CtaButton label="Get Third Molar Assessment Blueprint™ for $27" sub={null} data-id="element-324" data-mp="2x5zfxzk6nhah" />
            </div>
            <p className="mt-3 flex items-center justify-center gap-1.5 text-center text-sm text-muted" data-id="element-325" data-mp="324suzwf4bgcr">
              <LockIcon className="h-4 w-4" aria-hidden="true" data-id="element-326" data-mp="374faydmbzap9" />
              Secure Checkout · Instant Digital Delivery · 7-Day Guarantee
            </p>

            <Countdown data-id="element-327" data-mp="3b3xub4yi7dpz" />
          </div>
        </div>
      </div>
    </section>;
}